// extracted by mini-css-extract-plugin
export default {"packList":"PackLists_packList__14yCn"};